var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9226 8.33909C14.248 8.01365 14.248 7.48602 13.9226 7.16059C13.5972 6.83514 13.0695 6.83514 12.7441 7.16059L8.84459 11.0601L7.26694 9.42184C6.94771 9.09034 6.42016 9.08034 6.08864 9.39959C5.75713 9.71884 5.74717 10.2463 6.06641 10.5779L8.23308 12.8279C8.38826 12.9891 8.60176 13.0811 8.82551 13.0832C9.04918 13.0853 9.26443 12.9973 9.42259 12.8391L13.9226 8.33909Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.833328C4.9374 0.833328 0.833344 4.93739 0.833344 10C0.833344 15.0626 4.9374 19.1667 10 19.1667C15.0626 19.1667 19.1667 15.0626 19.1667 10C19.1667 4.93739 15.0626 0.833328 10 0.833328ZM2.50001 10C2.50001 5.85786 5.85788 2.49999 10 2.49999C14.1422 2.49999 17.5 5.85786 17.5 10C17.5 14.1422 14.1422 17.5 10 17.5C5.85788 17.5 2.50001 14.1422 2.50001 10Z",
    fill: "#CC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon1);
export default __webpack_public_path__ + "static/media/Approve-Icon1.4a5a5e2859a868ccb6250d9a3fce8a6d.svg";
export { ForwardRef as ReactComponent };